module.exports = __webpack_public_path__ + "img/2020_12_06_space_hopper.9d1a2fb2.jpg";